import { FishPrefab } from "./fish-prefab"
import { PrefabLoader } from "./prefab"

export class Fish3Loader extends PrefabLoader<FishPrefab> {
    path = "models/fish_01/"
    filename = "fish03.glb"
    prefabConstructor = FishPrefab
};